var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 160 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2948_12934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.495 97.2815C149.903 97.2815 146.988 94.3667 146.988 90.7752V47.4008C146.988 43.8093 149.903 40.8945 153.495 40.8945C157.086 40.8945 160.001 43.8093 160.001 47.4008V90.7752C160.001 94.3667 157.086 97.2815 153.495 97.2815Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.397 37.917L91.5728 3.01839C84.3212 -1.00613 75.6538 -1.00613 68.4022 3.01839L5.57769 37.917C2.14238 39.8262 0 43.4613 0 47.3984C0 51.3355 2.14238 54.9707 5.57769 56.8799L21.4363 65.6847V108.122C21.4363 124.518 51.7899 131.978 79.9927 131.978C108.196 131.978 138.549 124.518 138.549 108.122V65.6847L154.408 56.8799C157.843 54.9707 159.985 51.3376 159.985 47.3984C159.985 43.4593 157.843 39.8262 154.408 37.917H154.399H154.397ZM125.545 108.001C124.643 111.02 109.262 118.967 79.9927 118.967C50.7239 118.967 35.342 111.02 34.4489 108.124V72.9134L68.4105 91.7722C72.0374 93.7855 76.0182 94.7994 79.9906 94.7994C83.9631 94.7994 87.946 93.7938 91.5707 91.7722L125.532 72.9134V108.012L125.541 108.003L125.545 108.001ZM85.2498 80.3982C81.954 82.2283 78.0231 82.2283 74.7273 80.3982L15.3111 47.3901L74.7252 14.382C78.0211 12.5519 81.9602 12.5519 85.256 14.382L144.67 47.3901L85.256 80.3982H85.2477H85.2498Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2948_12934"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 131.98,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdu);
export default __webpack_public_path__ + "static/media/edu.14b64e52.svg";
export { ForwardRef as ReactComponent };